import React, { useState, useEffect } from 'react';
import '../styles/Navbar.css';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 40);
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  return (
    <nav className={`navbar${scrolled ? ' scrolled' : ''}`}>
      <a href="#inicio" className="nav-logo">
        GB <span>Agro</span>tech
      </a>

      <div className={`nav-links${menuOpen ? ' open' : ''}`}>
        <a href="#solucoes" onClick={() => setMenuOpen(false)}>Soluções</a>
        <a href="#sobre" onClick={() => setMenuOpen(false)}>Sobre nós</a>
        <a href="#contato" onClick={() => setMenuOpen(false)}>Contato</a>
        <a href="#contato" className="nav-cta" onClick={() => setMenuOpen(false)}>
          Fale conosco
        </a>
      </div>

      <button
        className="nav-burger"
        onClick={() => setMenuOpen(o => !o)}
        aria-label="Menu"
      >
        <span /><span /><span />
      </button>
    </nav>
  );
}
